import type { EffectCallback } from 'react';
import { useEffect } from 'react';

/** Helper wrapper around `useEffect` to avoid excessive `eslint-disable` comments for effects meant to run exactly once */
export const useEffectOnce = (effect: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps -- Only run the desired effect once
  useEffect(effect, []);
};
